module.exports = __webpack_public_path__ + "img/黃金萬兩_四方連續_彩稿.927a8c66.png";